// extracted by mini-css-extract-plugin
export default {"collectionMethodBox":"styles_collectionMethodBox__ELn85","image":"styles_image__3xCRO","title":"styles_title__dN3aK","selected":"styles_selected__poaD5"};